"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var l = require("lenovo");
var React = require("react");
var ReactDOM = require("react-dom");
var _errorBoxId = "Sale_Error";
var _errortModalId = "pcg_shop_error";
var Error = /** @class */ (function (_super) {
    __extends(Error, _super);
    function Error(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            title: l.Translator.translate('ps request error'),
            message: l.Translator.translate('failed')
        };
        return _this;
    }
    Error.prototype.componentDidMount = function () {
        var _this = this;
        window["onHandleShowError"] = function (title, message) {
            _this.setState({
                title: title || l.Translator.translate('ps request error'),
                message: message || l.Translator.translate('failed')
            });
            $("#" + _errortModalId).modal("show");
        };
    };
    Error.prototype.render = function () {
        var _a = this.state, title = _a.title, message = _a.message;
        return (React.createElement("div", { id: _errortModalId, className: "modal fade", role: "dialog", "aria-labelledby": "mySecondModalLabel", "aria-hidden": "true", style: { display: "none" }, tabindex: "-1" },
            React.createElement("div", { className: "modal-dialog caps-dialog", role: "document" },
                React.createElement("div", { className: "addToCart_popup addToCart_popup2" },
                    React.createElement("h4", null,
                        React.createElement("span", null,
                            " ",
                            title),
                        React.createElement("span", { className: "icon-l-close", onClick: function () { return $("#" + _errortModalId).modal('hide'); } })),
                    React.createElement("div", { className: "dialog-text" },
                        React.createElement("div", { style: { "fontSize": "20px", "lineHeight": "50px" } }, message))))));
    };
    return Error;
}(React.Component));
exports.render = function () {
    $("<div></div>").attr("id", _errorBoxId).appendTo("body");
    ReactDOM.render(React.createElement(Error, null), document.getElementById(_errorBoxId));
};
